module dg.actions {

    import ModelQueryBase = dg.domain.queries.ModelQueryBase;
    import ModelQueryResult = dg.domain.queries.ModelQueryResult;
    export interface IDashboardStateResolve extends angular.ui.IViewStateResolve {
        query?: (...args: any[]) => ModelQueryBase<dg.domain.IDomainObject> | ng.IPromise<ModelQueryBase<dg.domain.IDomainObject>>;
        link?(...args: any[]): dg.restfulApi.Link | ng.IPromise<dg.restfulApi.Link>;
        //headerUrl?(...args: any[]): string | ng.IPromise<string>;
        dashboardTitle?(...args: any[]): string | ng.IPromise<string>;
        dashboardSubtitle?(...args: any[]): string | ng.IPromise<string>;
    }

    export class DashboardController {

        public queryManipulator: dg.actions.ServerQueryManipulator;
        public query: ModelQueryBase<dg.domain.IDomainObject>;
        public queryResult: ModelQueryResult<dg.domain.IDomainObject>;

        public title: string;
        public subtitle: string;
        public templateUrl: string;
        public dashboardUrl: string;
        public stateName: string;
        public bodyStyle = { height: '0px' };
        public bodyHeight: number;

        public constructor(protected actionService: dg.actions.ActionService,
            private $scope: ng.IScope,
            private $q: ng.IQService,
            private $element: ng.IAugmentedJQuery,
            private $window: ng.IWindowService,
            private $state: ng.ui.IStateService) {

            this.stateName = this.$state.current.name;
        }

        $onInit() {

            angular.element(document).ready(() => {
                this.recalculateBodyHeight();
                this.recalculateHeights();

                angular.element(this.$window).on('resize', this.resize);
            });

            this.dashboardUrl = '/app/src/' + this.templateUrl + '-dashboard.html';


            this.queryManipulator = new ServerQueryManipulator(this.$scope, this.$q, this.query, this.actionService);
            this.queryManipulator.executeQuery();
            this.queryManipulator.onResultChanged(this.resultChangeHandler);
        }

        $onDestroy() {
            angular.element(this.$window).off('resize', this.resize);
        }

        private resultChangeHandler = () => {
            this.queryResult = this.queryManipulator.result;
            //this.loading.loaded = true;
        }

        private resize = () => {
            this.recalculateBodyHeight();
            this.recalculateHeights();
        }

        private recalculateHeights = () => {
            this.bodyStyle.height = this.bodyHeight + 'px';
        }

        private recalculateBodyHeight = () => {
            this.bodyHeight = 5 + dgUtils.UiService.recalculateViewHeight(this.$window.innerHeight);
        }

    }
    angular.module('dg.actions').component('dashboard', {
        bindings: {
            query: '<',
            title: '<',
            subtitle: '<',
            templateUrl: '@'
        },
        controller: DashboardController,
        templateUrl: '/digmo/src/actions/dashboard/dashboard.html'
    });
}